export default "__VITE_ASSET__CYFm2ThG__"